<template>
    <div>

    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {}
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped lang="scss">

</style>